'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchAboutDataIfNeeded = exports.shouldFetchAboutData = exports.LOAD_ABOUT_DATA_SUCCESS = exports.LOAD_ABOUT_DATA_REQUEST = exports.LOAD_ABOUT_DATA_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _config = require('./config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ABOUT_DATA_FAIL = exports.LOAD_ABOUT_DATA_FAIL = 'la/domain/about/LOAD_FAIL';
var LOAD_ABOUT_DATA_REQUEST = exports.LOAD_ABOUT_DATA_REQUEST = 'la/domain/about/LOAD_REQUEST';
var LOAD_ABOUT_DATA_SUCCESS = exports.LOAD_ABOUT_DATA_SUCCESS = 'la/domain/about/LOAD_SUCCESS';

// reducer
var DEFAULT_STATE = {};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.about;
};

var shouldFetchAboutData = exports.shouldFetchAboutData = (0, _reselect.createSelector)(stateSelector, function (state) {
    return true;
});

/* ACTION CREATORS */
var loadAboutData = function loadAboutData() {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: LOAD_ABOUT_DATA_REQUEST
                            });
                            _context.next = 6;
                            return _api.Page.fetchAboutData({ deployment: deployment });

                        case 6:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_ABOUT_DATA_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LOAD_ABOUT_DATA_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchAboutDataIfNeeded = exports.fetchAboutDataIfNeeded = function fetchAboutDataIfNeeded() {
    return function (dispatch, getState) {
        if (shouldFetchAboutData(getState())) {
            return dispatch(loadAboutData());
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/about.js
// module id = gJIA
// module chunks = 60